<template>
    <Form ref="form" :rules="rules" :model="formData" :label-width="form.labelWidth || 100" @on-validate="handleValidate">
      <div v-if="!form.layout" class="l-form-empty">
        表单未配置
      </div>
      <template v-else-if="segments.length > 0">
        <BaseSegment v-for="(s,i) in segments" :icon="s.icon" :disabled="true" :required="s.required" v-if="!s.if || formData[s.if] " :title="s.title" style="margin-bottom:10px" :desc="s.desc" :key="'_seg'+i">
          <Row v-for="(line,j) in s.lines" :key="`_line${j}`">
            <template v-for="(f,k) in line.fields">
              <Col :span="f.span || 24" :key="'col_formItem_'+f.name+i+j+k">
              <FormItem v-if="!f.as_item" :label="f.name" :prop="f.key" :key="'_formItem_'+f.name+i+j+k" :required="f.required"  :label-position="f.labelPosition">
                <component :ref="f.key" :is="f.control" v-model="formData[f.key]"  @input="emitChange" :model="formData" v-bind="f.option" />
                 <div style="color:var(--warning);margin-top:3px;" v-if="old[f.key] != formData[f.key]">- 修改前 ： {{old[f.key] || '无'}}</div>
                <div style="color:var(--primary);margin-top:3px;" v-if="f.desc"><BaseIcon icon="info" /> {{f.desc}}</div>
              </FormItem>
              <template v-else>
                <div :key="'_formItemc_'+f.name+i+j+k" >
                <component :ref="f.key" :is="f.control" v-model="formData[f.key]" v-bind="f.option"  :model="formData"  @input="emitChange" />
                 <div style="color:var(--primary);margin-top:3px;" v-if="value[f.key] !== formData[f.key]"><BaseIcon icon="ios-clock" /> {{value[f.key]}}</div>
                <div v-if="f.desc">{{f.desc}}</div>
                </div>
              </template>
              </Col>
            </template>
          </Row>
        </BaseSegment>
      </template>
      <template v-else-if="lines.length > 0">
        <BaseLine v-for="(line,j) in form.layout.lines" :key="`_line${j}`">
          <template v-for="(f,k) in line.fields">
            <FormItem v-if="!f.as_item" :label="f.name" :prop="f.key" :key="'_formItem_'+f.name+i+j+k" :required="f.required" :label-position="f.labelPosition">
              <component :ref="f.key" :is="f.control" v-model="formData[f.key]" @input="emitChange" v-bind="f.option" :model="formData" />
              <span v-if="f.desc">{{f.desc}}</span>
            </FormItem>
            <template v-else>
              <div :key="'_formItem_'+f.name+i+j+k">
                <component :ref="f.key" :is="f.control" v-model="formData[f.key]" @input="emitChange" v-bind="f.option"  :model="formData" />
                <span v-if="f.desc">{{f.desc}}</span>
              </div>
            </template>
          </template>
        </BaseLine>
      </template>
      <template v-else-if="form.tpl">
        <BaseTpl :data="form.layout" :fields="form.fields" v-model="formData" />
      </template>
      <div v-else class="l-form-empty">
        表单配置错误
      </div>
    </Form>
  </template>
  
  <script>
  import {cloneDeep, pick} from 'lodash';
  export default {
    data() {
      return {
        formData: {},
  
      };
    },
    mounted() {
      this.formData = cloneDeep(pick(this.value, Object.keys(this.form.fields)));
    },
    props: {
      value: {
        type: Object,
        default: () => ({}),
      },
      old: {
        type: Object,
        default: ()=>({}),
      },
      form: {
        type: Object,
        default: ()=>({}),
      },
      update: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      rules() {
        const r = {};
        for (const key in this.form.fields) {
          const field = this.form.fields[key];
          field.key = key;
          if (field.rules) {
            r[key] = field.rules;
          } else if (field.required) {
            r[key] = [{required: true, message: `此项为必填项`}];
          }
        }
        return r;
      },
      segments() {
        if (Array.isArray(this.form.layout)) {
          return this.form.layout.map((v) => {
            return {
              title: v.name,
              desc: v.desc,
              icon: v.icon,
              required: v.required,
              if: v.if,
              lines: v.lines.map((l) => {
                const line = {
                  fields: [],
                };
                if (Array.isArray(l)) {
                  line.fields = l.map((f) => this.form.fields[f]).filter((v) => v);
                } else if (typeof l == 'string') {
                  line.fields = this.form.fields[l] ? [this.form.fields[l]] : null;
                } else {
                  return;
                }
                return line;
              }).filter((v) => v),
            };
          });
        } else {
          return [];
        }
      },
      line() {
        if (this.form.simple && Array.isArray(this.form.layout.lines)) {
          return this.form.layout.lines.map((l) => {
            const line = {
              fields: [],
            };
            if (Array.isArray(l)) {
              line.fields = l.map((f) => this.form.fields[f]).filter((v) => v);
            } else if (typeof l == 'string') {
              line.fields = this.form.fields[l] ? [this.form.fields[l]] : null;
            } else {
              return;
            }
            return line;
          }).filter((v) => v);
        } else {
          return [];
        }
      },
    },
    methods: {
      validate(func) {
        this.focused =false;
        this.$refs.form.validate(func);
      },
      reset() {
        this.$refs.form.resetFields();
      },
      handleValidate(prop, status, error) {
        if (!this.focused && !status && this.$refs[prop] && typeof this.$refs[prop][0].focus == 'function') {
          this.focused = true;
          this.$refs[prop][0].focus();
        }
      },
      emitChange() {
        this.$emit('input', Object.assign({}, this.value, this.formData));
      },
    },
  };
  </script>
  
  <style lang="less">
  .l-form-empty {
    background: #33333311;
    min-height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--subtext3);
  }
  </style>
  